// @flow
import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { FaHeart, FaRegComment, FaRegHeart, FaRegThumbsUp, FaTrashAlt } from 'react-icons/fa';

import FakeLink from 'components/common/FakeLink';
import { type UserHistoryItem } from 'store/modules/profile';
import { onlyUpdateForKeys } from 'recompose';
import './UserHistory.scss';
import Button from '../../common/Button';
import { ProfileActions } from '../../../store/actionCreators';

type HistoryItemProps = {
  username: string,
  item: UserHistoryItem,
};

const HistoryItem = onlyUpdateForKeys(['item', 'username'])(
  ({ item, username }: HistoryItemProps) => {
    const menu = item.post ? 'post' : 'product';
    let url = `/@${item[menu].user.username}/${item[menu].url_slug}`;
    if (menu === 'product') {
      url = `/@${item[menu].user.username}/products/${item[menu].url_slug}`;
    }
    const { type } = item;

    let message;
    switch (type) {
      // case 'comment':
      //   message = (
      //     <div className="msg">
      //       <FaRegComment className="icon" />이 포스트에 댓글을 남기셨습니다.
      //     </div>
      //   );
      //   break;
      // case 'comments_products':
      //   message = (
      //     <div className="msg">
      //       <FaRegComment className="icon" />이 상품에 댓글을 남기셨습니다.
      //     </div>
      //   );
      //   break;
      // case 'like':
      //   message = (
      //     <div className="msg">
      //       <FaRegThumbsUp className="icon" />
      //       {`이 포스트에 '좋아요' 하셨습니다.`}
      //     </div>
      //   );
      //   break;
      case 'product_like':
        message = (
          <div className="msg">
            <FaHeart className="icon" />
            {`이 상품을 '찜' 하셨습니다.`}
          </div>
        );
        break;
      default:
        break;
    }
    return (
      <FakeLink className="HistoryItem">
        <div className="mini-postcard">
          {item[menu].thumbnail && (
            <Fragment>
              <Link to={url}>
                <div className="thumbnail">
                  <img src={item[menu].thumbnail} alt="thumbnail" />
                </div>
              </Link>
              <div className="separator" />
            </Fragment>
          )}
          <div className="post-info">
            <h4>
              <Link to={url}>{item[menu].title}</Link>
            </h4>
            {message}
          </div>
          <div className="post-button">
            <Button color={"red"} onClick={() => ProfileActions.removeUserHistory(item.fk_product_id)}>
              <FaTrashAlt />
            </Button>
          </div>
        </div>
      </FakeLink>
    );
  },
);

const HistoryItemPlaceholder = () => {
  return (
    <div className="HistoryItem placeholder">
      <div className="mini-postcard">
        <div className="thumbnail">
          <div className="fake-img gray-box" />
        </div>
        <div className="separator" />
        <div className="post-info">
          <h4>
            <span className="gray-box" style={{ width: '50%' }} />
          </h4>
          <div className="msg gray-box" style={{ width: '30%' }} />
        </div>
      </div>
    </div>
  );
};

type Props = {
  username: ?string,
  data: ?(UserHistoryItem[]),
  loading: boolean,
};

class UserHistory extends Component<Props> {
  renderList() {
    const { username, data } = this.props;
    if (!data || !username) return null;
    return data.map(item => <HistoryItem username={username} item={item} key={item.id} />);
  }

  render() {
    return (
      <div className="UserHistory">
        {this.props.data && this.props.data.length === 0 && !this.props.loading && (
          <div className="no-history">찜 내역이 없습니다.</div>
        )}
        {this.renderList()}
        {this.props.loading && (
          <Fragment>
            <HistoryItemPlaceholder />
            <HistoryItemPlaceholder />
            <HistoryItemPlaceholder />
            <HistoryItemPlaceholder />
          </Fragment>
        )}
      </div>
    );
  }
}

export default onlyUpdateForKeys(['username', 'data', 'loading'])(UserHistory);



// WEBPACK FOOTER //
// ./src/components/user/UserHistory/UserHistory.js